import { Tag, Tooltip } from "antd";
import {
	EditOutlined,
	CheckOutlined,
	ClockCircleOutlined,
	ExclamationOutlined,
	LockFilled,
	CloseOutlined,
	CalendarOutlined,
} from "@ant-design/icons";

const StatusTag = ({ status }) => {
	const CustomTag = ({ tooltip, color, icon, text }) => {
		return (
			<Tooltip title={tooltip}>
				<Tag color={color} className="tag-status">
					{icon} {text}
				</Tag>
			</Tooltip>
		);
	};

	switch (status) {
		case "Draft":
			return (
				<CustomTag
					tooltip="Complete and submit this form for approval"
					color="default"
					icon={<EditOutlined />}
					text="Draft"
				/>
			);
		case "Pending":
		case "Submitted":
			return (
				<CustomTag
					tooltip="Waiting for workflow approval to complete"
					color="blue"
					icon={<ClockCircleOutlined />}
					text="Pending Approval"
				/>
			);
		case "Roster":
			return (
				<CustomTag
					tooltip="Waiting for leave to be rostered"
					color="purple"
					icon={<CalendarOutlined />}
					text="Pending Roster"
				/>
			);
		case "Declined":
			return (
				<CustomTag
					tooltip="A workflow approver has declined - the form must be reviewed / edited and resubmitted for approval"
					color="red"
					icon={<ExclamationOutlined />}
					text="Declined"
				/>
			);
		case "Approved":
			return (
				<CustomTag
					tooltip="Fully approved form"
					color="green"
					icon={<CheckOutlined />}
					text="Approved"
				/>
			);
		case "Locked":
			return (
				<CustomTag
					tooltip="This form is locked from editing and cannot be changed - contact the admin to unlock this form if changes are required"
					color="gold"
					icon={<LockFilled />}
					text="Locked"
				/>
			);
		case "Cancelled":
			return (
				<CustomTag
					tooltip="This form was cancelled after it was submitted. It is no longer pending approval and needs to be submitted again."
					color="default"
					icon={<CloseOutlined />}
					text="Cancelled"
				/>
			);
		case "Closed":
			return (
				<CustomTag
					tooltip="This form is finalised and can only be viewed"
					color="gold"
					icon={<LockFilled />}
					text="Finalised"
				/>
			);
		default:
			return <>Error: Status of {status} is not recognised</>;
	}
};

export default StatusTag;
